export default "__VITE_ASSET__CfG00HMm__"